export const cveColorTheme = {
  cve: {
    default: {
      color: 'colorRiskBenign'
    },
    no: {
      color: 'colorRiskBenign'
    },
    'no known': {
      color: 'colorRiskBenign'
    },
    'no data': {
      color: 'colorRiskBenign'
    },
    low: {
      color: 'colorRiskLow'
    },
    anticipated: {
      color: 'colorRiskLow'
    },
    benign: {
      color: 'colorRiskBenign'
    },
    medium: {
      color: 'colorRiskMedium'
    },
    available: {
      color: 'colorRiskMedium'
    },
    high: {
      color: 'colorRiskHigh'
    },
    confirmed: {
      color: 'colorRiskHigh'
    },
    critical: {
      color: 'colorRiskCritical'
    },
    wide: {
      color: 'colorRiskCritical'
    },
    yes: {
      color: 'colorRiskCritical'
    },
    none: {
      color: 'colorRiskBenign'
    },
    easy: {
      color: 'colorRiskLow'
    },
    moderate: {
      color: 'colorRiskMedium'
    },
    difficult: {
      color: 'colorRiskHigh'
    },
  }
}

export const v2StringMap = (value) => {
  if (!value) {
    return { label: 'No data', color: cveColorTheme.cve.default }
  }
  if (value < 4) {
    return { label: 'Low', color: cveColorTheme.cve.low }
  }
  if (value < 7) {
    return { label: 'Medium', color: cveColorTheme.cve.medium }
  }
  if (value < 9) {
    return { label: 'High', color: cveColorTheme.cve.high }
  }
  return { label: 'Critical', color: cveColorTheme.cve.critical }
}

export const v3StringMap = (value) => {
  if (value === 0) {
    return { label: 'None', color: cveColorTheme.cve.none }
  }
  if (!value) {
    return { label: 'No data', color: cveColorTheme.cve.default }
  }
  if (value < 4) {
    return { label: 'Low', color: cveColorTheme.cve.low }
  }
  if (value < 7) {
    return { label: 'Medium', color: cveColorTheme.cve.medium }
  }
  if (value < 9) {
    return { label: 'High', color: cveColorTheme.cve.high }
  }
  return { label: 'Critical', color: cveColorTheme.cve.critical }
}
